export const MusicIcon2 = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={25}
            viewBox="0 0 24 25"
            fill="none"
        >
            <path
                d="M11 16.0404C10.1788 15.8871 9.20743 16.0224 8.28747 16.4819C6.47474 17.3872 5.5481 19.2081 6.21776 20.5489C6.88742 21.8898 8.8998 22.2428 10.7125 21.3374C12.1034 20.6428 12.9732 19.4092 13 18.267V7.44359L18 10.3303V8.02094L11 3.97949L11 16.0404Z"
                fill="#ffffff"
            />
        </svg>
    )
}